import React from 'react'
import ApiUrl from '../../configTools/apiUrl';
import { Link,Navigate } from 'react-router-dom';
import { useState,useEffect } from 'react';
import '../../css/public/checkout.css'
import Button from '../../components/forms/blackfillButton';
import Logo2 from '../../images/logo4.jpg'
import FormInput from '../../components/forms/formInput';
import FormSelect from '../../components/forms/formSelect';

const Checkout = () => {
  const User = JSON.parse(localStorage.getItem("user-info"));
  const [bag,setBag] = useState(JSON.parse(localStorage.getItem("product-cart")));
  const [bagsum,setBagSum] = useState(0);
  const [location,setLocation] = useState({name:'Select', value:'0'});
  const [locationList,setLocationList] = useState([]);
  const [contact, setContact] = useState('')
  const [address, setAddress] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [complete, setComplete] = useState([]);

  const [shippingcost, setshippingcost] = useState(0);
  const [paymentMetord, setPaymentMetord] = useState(1);
  const [spdiscount, setSpdiscount] = useState(14);

  const checkoutfacebook = ()=>{
    //fbq('track','event');
  }

  useEffect(()=>{
    if(bag){
      const sum = bag.reduce((accumulator, object) => {
        return accumulator + object.price;
      }, 0);
      setBagSum(sum);

      let bagList = bag;
      var previd = [];

      for (let index = 0; index < bagList.length; index++) {
        const element = bagList[index];
        var exist = false;
        for (let i = 0; i < previd.length; i++) {
          const element1 = previd[i];
          if(element.sellerid === element1){
            exist = true;
          }
        }
        if(!exist){
          previd.push(element.sellerid);
        }
      }
      setshippingcost(previd.length*79);
    }
  },[bag])
  useEffect(() => {
      fetch(ApiUrl.API_URL_Location)
      .then(res=>res.json())
      .then(data =>{
          let locationListSend = [];
          for (let index = 0; index < data.length; index++) {
              const element = data[index];
              locationListSend.push({
                  name: element.name,
                  value: String(element.id)
              })
          }
          setLocationList(locationListSend);
          if(User){
            setAddress(User.address);
            setContact(User.contact);
            setEmail(User.email);
            setLocation(locationListSend.find(x=>x.value === String(User.location)));
          }
      });
  },[])
  const addToApi = ()=>{
    if(contact === '' || address === '' || location.value == '0' || location.value == 0){
      alert('please fill delivery details');
      return;
    }
    var orderlineitem = [];
    for (let index = 0; index < bag.length; index++) {
      const element = bag[index];
      orderlineitem.push({
        productid : element.productid,
        varientid : element.varinetid,
        hasvarient : element.hasvarients,
        size : element.size,
        sizeName : element.sizeName,
        color : element.color,
        colorname : element.colorcode,
        price: element.price,
        image: element.image,
        title: element.title,
        slug: element.slug,
        orderid:0,
        sellerid:element.sellerid
      })
    }
    if(orderlineitem.length === 0){
      alert('please add products to cart');
      return;
    }
    if(User){
      fetch(ApiUrl.API_URL_Orders, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            id : 0,
            user : User.id,
            total : bagsum,
            shippingcost : shippingcost,
            gtotal : bagsum+shippingcost,
            paymentmethord : paymentMetord,
            contact : contact,
            address : address,
            location : parseInt(location.value),
            itemcount : bag.length,
            paymentstatus : 0,
            fulfilmentstatus : 0,
            lineitems : orderlineitem,
            name: name,
            email: email
          })
        })
        .then(res2=>res2.json())
        .then(data2 =>{
          if(data2.success){
            setComplete(data2.id);
            localStorage.setItem("product-cart",JSON.stringify([]));
            if(paymentMetord === 2){
              window.open('https://api.postex.pk/services/payment/api/custom/plugin/v1?merchantCode=KAAY&apiKey=NzA2ODUzMGZiODYyNDQyMjgxNzJmNDg5Mjg3NTBiNzA6ZWYxOTFkZjYzYWQ3NGQ2M2IzMTg5MzA5YWFjODBlZGE=&orderRefNum='+data2.payment+'&amount='+(bagsum+shippingcost)+'&customerName='+name+'&customerPhoneNum='+contact+'&customerAddress='+address)
            }
          }
          else{
            alert('something went wrong');
            console.log(data2.responce);
          }
      });
    }
    else{
      fetch(ApiUrl.API_URL_OrdersUn, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id : 0,
          user : 0,
          total : bagsum,
          shippingcost : shippingcost,
          gtotal : bagsum+shippingcost,
          paymentmethord : paymentMetord,
          contact : contact,
          address : address,
          location : parseInt(location.value),
          itemcount : bag.length,
          paymentstatus : 0,
          fulfilmentstatus : 0,
          lineitems : orderlineitem,
          name: name,
          email: email
        })
      })
      .then(res2=>res2.json())
      .then(data2 =>{
        if(data2.success){
          setComplete(data2.id);
          localStorage.setItem("product-cart",JSON.stringify([]));
          if(paymentMetord === 2){
            window.open('https://api.postex.pk/services/payment/api/custom/plugin/v1?merchantCode=KAAY&apiKey=NzA2ODUzMGZiODYyNDQyMjgxNzJmNDg5Mjg3NTBiNzA6ZWYxOTFkZjYzYWQ3NGQ2M2IzMTg5MzA5YWFjODBlZGE=&orderRefNum='+data2.payment+'&amount='+(bagsum+shippingcost)+'&customerName='+name+'&customerPhoneNum='+contact+'&customerAddress='+address)
          }
        }
        else{
          alert('something went wrong');
          console.log(data2.responce);
        }
    });
    }
  }
  return (
    <div className='checkout_container'>
      <div className='checkout_details'>
        <div className='checkout_details_logo_container'>
          <div className='checkout_details_logo'>
            <Link to={'/'}>
              <img src={Logo2} alt='logo'/>
            </Link>
          </div>
          <div className='checkout_details_button'>
            <Link to={'/'}><Button Value={'Back to shopping'}/></Link>
          </div>
        </div>
        {complete.length === 0 &&
          <>
            {User &&
              <>
                <div className='checkout_details_user_container'>
                  <div className='checkout_details_user_image'>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+User.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}>
                    </div>
                  </div>
                  <div className='checkout_details_user_details'>
                    <h3>{User.firstname+" "+User.lastname}</h3>
                    <h4>{"@"+User.username}</h4>
                  </div>
                </div>
              </>
            }
            <div className='checkout_details_payment_container'>
              <h3>Payment Methord</h3>
              <div className='checkout_details_payment_list'>
                <div className={'checkout_details_payment_list_item' + (paymentMetord === 1? ' selected' : '')} onClick={
                  ()=>{setPaymentMetord(1)}
                }>
                  <p>Cash on Delivery</p>
                </div>
                <div className={'checkout_details_payment_list_item' + (paymentMetord === 2? ' selected' : '')} onClick={
                  ()=>{setPaymentMetord(2)}
                }>
                  <p>Paid by Postex</p>
                </div>
              </div>
            </div>
            <div className='checkout_details_address_container'>
              <h3>Delivery</h3>
              {!User &&
                <FormInput Lable='Name' Type='text' Placeholder='Enter full name' Value={name} setValue={setName}/>
              }
              <FormInput Lable='Email' Type='text' Placeholder='Enter Email' Value={email} setValue={setEmail}/>
              <FormInput Lable='Contact' Type='text' Placeholder='Enter Contact' Value={contact} setValue={setContact}/>
              <FormInput Lable='Address' Type='text' Placeholder='Enter Address' Value={address} setValue={setAddress}/>
              <FormSelect Lable={'Location'} Value={location} setValue={setLocation} Options={locationList}/>
            </div>
          </>
        }
        {complete.length !== 0 &&
          <div className='checkout_details_complete_container'>
            <h3>Thank you for your purchase</h3>
            <p>Your order# are {complete.map((item,index)=>{
              return(
                <span key={index}>{item},</span>
              )
            })} your order will be delivered to you with in given time by your seller. if you ordered from multiple sellers you will recieve it in multiple packages.</p>
          </div> 
        }
      </div>
      <div className='checkout_listings'>
        <div className='checkout_listings_items'>
          {bag &&
            bag.map((item,index)=>{
              return(
                <div key={index} className='checkout_box_item'>
                  <div className='checkout_box_item_image'>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}></div>
                  </div>
                  <div className='checkout_box_item_details'>
                    <Link to={"/product/"+item.slug}>
                      <h5>{item.title}</h5>
                    </Link>
                    {item.hasvarients &&
                      <div className='checkout_box_item_details_container'>
                        <div className='checkout_box_item_details_item'>
                          <p>Size:</p>
                          <p>{item.sizeName}</p>
                        </div>
                        <div className='checkout_box_item_details_item'>
                          <p>Color:</p>
                          <div style={{backgroundColor:item.colorcode}} className={"checkout_box_item_details_item_colorcode"}></div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className='checkout_box_item_price'>
                    <p>{"Rs."+item.price+"/-"}</p>
                  </div>
                </div>
              )
            })
          }
        </div>
        <div className='checkout_listings_total'>
          <div className='checkout_listings_total_item'>
            <div className='checkout_listings_total_title'><h5>Sub Total</h5></div>
            <div className='checkout_listings_total_title'><h5>Rs {bagsum}/-</h5></div>
          </div>
          <div className='checkout_listings_total_item'>
            <div className='checkout_listings_total_title'><h5>Shipping Fee</h5></div>
            <div className='checkout_listings_total_title'><h5>Rs {shippingcost}/-</h5></div>
          </div>
          <div className='checkout_listings_total_item'>
            <div className='checkout_listings_total_title'><h5>Grand Total</h5></div>
            <div className='checkout_listings_total_title'><h5>Rs { bagsum+shippingcost }/-</h5></div>
          </div>
          {complete.length === 0 &&
            <Button Value={"Complete Purchase"} Action={addToApi} />
          }
        </div>
      </div>
    </div>
  )
}

export default Checkout
